var map = {
	"./Screenshot 2024-02-22 at 11.42.23.png": 435,
	"./aaple.png": 404,
	"./amazon.png": 55,
	"./apple.png": 491,
	"./btc.png": 942,
	"./eth.png": 42,
	"./eur.png": 375,
	"./gold.png": 465,
	"./illustration.png": 873,
	"./loading.svg": 307,
	"./s.png": 496,
	"./sol.png": 605,
	"./usdc.svg": 490,
	"./usdt.png": 807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;